<template>
  <div class="w-full">
    <vs-row vs-justify="center">
      <vs-col vs-lg="5" vs-sm="12" class="text-left">
        <vs-row>
          <vs-col vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="12">
            <vs-select
              autocomplete
              class="selectExample w-full md:full px-0 md:px-2"
              v-model="questionsByPage[index].actions.mode"
              :label="$t('MODULE.actions.actionMode')"
            >
              <vs-select-item
                :key="index"
                :value="item"
                :text="$t(`MODULE.actions.${item}`)"
                v-for="(item, index) in mode"
              />
            </vs-select>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="12">
            <vs-select
              autocomplete
              class="selectExample mt-5 w-full md:full px-0 md:px-2"
              v-model="questionsByPage[index].actions.operation"
              :label="$t('MODULE.actions.typeAction')"
              @change="questionsByPage[index].properties.default = format[0]"
            >
              <vs-select-item
                :key="index"
                :value="item"
                :text="$t(`MODULE.actions.${item}`)"
                v-for="(item, index) in actions"
              />
            </vs-select>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="12">
            <vs-select
              autocomplete
              class="selectExample mt-5 w-full md:full px-0 md:px-2"
              v-model="questionsByPage[index].properties.default"
              :label="$t('MODULE.actions.formatDisplay')"
            >
              <vs-select-item
                :key="index"
                :value="item"
                :text="$t(`MODULE.actions.${item}`)"
                v-for="(item, index) in format"
              />
            </vs-select>
          </vs-col>
        </vs-row>
      </vs-col>
      <vs-col vs-lg="7" vs-sm="12" class="text-left">
        <div class="w-full h-full">
          <div class="flex flex-col md:flex-row">
            <vs-button color="success" type="border" class="w-full" @click="ShowModal()">Agregar preguntas</vs-button>
            <vs-button v-if="isSubFormualrio === '0'" color="success" type="border" class="w-full" @click="ShowModalSuForm()">
              agregar subformularios
            </vs-button>
          </div>

          <div
            :id="`container_questions_${index}`"
            class="border border-inherit rounded overflow-y-auto mt-1"
            :style="{ height: heigth }"
          >
            <!-- <div v-if="!stop" class="flex flex-wrap p-2"> -->
            <draggable v-if="!stop" v-model="questions" tag="div" class="flex flex-wrap p-2 cursor-move">
              <div
                v-for="(question, index) in questions"
                :key="index"
                class="bg-white border border-inherit mr-1 mb-1 p-1 px-5 rounded relative"
              >
                <div>
                  <b>ID:</b> <i>{{ question.name }}</i>
                </div>
                <div>{{ question.label }}</div>
                <div @click="remove(question.name)" class="absolute top-0 right-0 mr-1 cursor-pointer">X</div>
              </div>
            </draggable>
            <!-- </div> -->
          </div>
        </div>
      </vs-col>
    </vs-row>
  </div>
</template>

<script type="text/javascript">
import VModalPopup from "@/serviforms/designer/components/Modals/compounds/Main.vue";
import { mapState, mapMutations, mapGetters } from "vuex";
import { getAllQuestion } from "@/serviforms/designer/indexDB/logic.js";
import draggable from "vuedraggable";

export default {
  props: ["index"],
  components: { VModalPopup, draggable },
  data: () => ({
    // format: ["default", "number", "currency", "percent"],
    defaultFormat: ["default", "number", "currency"],
    getFormat: {},
    actions: ["add", "sub", "multiply", "divider", "concat", "avg", "mode", "median", "min", "max"],
    mode: ["on_trigger", "on_event", "on_depend"],
    search: "",
    allQuestions: [],
    heigth: "100%!important",
    stop: true
  }),
  mounted() {
    this.observeHeight();
    this.migrateQuestionsToData();
    this.getFormat = {
      add: this.defaultFormat,
      sub: this.defaultFormat,
      multiply: this.defaultFormat,
      divider: [...this.defaultFormat, "percent"],
      concat: ["semicolon", "underscore", "pipe", "comma", "dash", "space"],
      avg: this.defaultFormat,
      mode: this.defaultFormat,
      median: this.defaultFormat,
      min: this.defaultFormat,
      max: this.defaultFormat
    };
  },
  computed: {
    ...mapGetters("resource", ["isSubFormualrio"]),
    ...mapState("resource", ["questionsByPage"]),
    questions: {
      get() {
        return this.questionsByPage[this.index].actions.questions.map(question => {
          const result = this.allQuestions.find(subQuestion => subQuestion.name === question.name);
          return {
            ...question,
            label: result !== null && result !== undefined ? result.label : ""
          };
        });
      },
      set(question) {
        this.questionsByPage[this.index].actions.questions = question.map(
          ({ name, position, type, formID, questions }) => ({
            position,
            name,
            type,
            ...(formID && { formID, questions })
          })
        );
      }
    },
    format() {
      return this.getFormat[this.questionsByPage[this.index].actions.operation];
    }
  },
  methods: {
    ...mapMutations("resource", ["UPDATE_STATE"]),
    /**
     * Redimensiona el container <html> que  las preguntas que afectaran a la acción.
     */
    observeHeight() {
      const resizeObserver = new ResizeObserver(() => {
        const height = document.getElementById(`container_questions_${this.index}`).clientHeight;

        if (height > 0 && this.stop) {
          this.heigth = `${document.getElementById(`container_questions_${this.index}`).clientHeight}px!important`;
          this.stop = false;
          return;
        }

        if (height === 0) {
          this.heigth = "100%!important";
          this.stop = true;
        }
      });

      resizeObserver.observe(document.getElementById(`container_questions_${this.index}`));
    },
    /**
     * Remueve una pregunta de la lista dempreguntas que afectaran la operación de la acción.
     * @param {string} name - ID de la pregunta ejemplo: P_0
     */
    remove(name) {
      this.questionsByPage[this.index].actions.questions = this.questionsByPage[this.index].actions.questions.filter(
        question => question.name !== name
      );
    },
    /**
     * Muestra el modal para la configuración de las acciones
     */
    async ShowModal() {
      this.UPDATE_STATE({ key: "activePopup", value: true });
      this.UPDATE_STATE({ key: "componentPopup", value: "Actions" });
      this.UPDATE_STATE({ key: "indexQuestion", value: this.index });
      const result = await getAllQuestion();
      this.allQuestions = result;
    },
    /**
     * Muestra el modal para con la lista de subformularios para agregar a las acciones
     */
    async ShowModalSuForm() {
      this.UPDATE_STATE({ key: "activePopup", value: true });
      this.UPDATE_STATE({ key: "componentPopup", value: "ActionSubForm" });
      this.UPDATE_STATE({ key: "indexQuestion", value: this.index });
      const result = await getAllQuestion();
      this.allQuestions = result;
    },
    async migrateQuestionsToData() {
      const result = await getAllQuestion();
      this.allQuestions = result;
    }
  }
};
</script>

<style type="text/css">
.Component_actions {
  background-color: rgba(250, 250, 250, 0.7) !important;
}
.Component_actions .vs-popup--content {
  margin: 0px !important;
}
</style>
